import {
  EmailNotificationRoleAccess,
  NovuWorkflowOption,
  ReplaceEmailNotificationRoleAccess,
  UserEmailNotificationPreference,
  UserEmailNotificationPreferenceItem,
} from '@/types';
import {
  Core,
  EMAIL_NOTIFICATION_ROLE_ACCESS,
  EMAIL_NOTIFICATION_WORKFLOWS,
  USER_EMAIL_NOTIFICATION_PREFERENCES,
} from '../Core';

class EmailNotifications extends Core {
  getRoleAccess = async (userType?: string, userRole?: string) => {
    const params = new URLSearchParams();
    if (userType) params.set('userType', userType);
    if (userRole) params.set('userRole', userRole);
    const query = params.toString();
    return this.get<EmailNotificationRoleAccess[]>(
      `${EMAIL_NOTIFICATION_ROLE_ACCESS()}${query ? `?${query}` : ''}`,
    );
  };

  getWorkflows = async () =>
    this.get<NovuWorkflowOption[]>(EMAIL_NOTIFICATION_WORKFLOWS());

  replaceRoleAccess = async (data: ReplaceEmailNotificationRoleAccess) =>
    this.put(EMAIL_NOTIFICATION_ROLE_ACCESS(), data);

  getMyPreferences = async () =>
    this.get<UserEmailNotificationPreference[]>(
      USER_EMAIL_NOTIFICATION_PREFERENCES(),
    );

  updateMyPreferences = async (items: UserEmailNotificationPreferenceItem[]) =>
    this.patch(USER_EMAIL_NOTIFICATION_PREFERENCES(), { items });
}

export const emailNotifications = new EmailNotifications();
